// Constants
import { BASE_URL } from '../config'
import loSto from '../config/loSto'

const EMR_TOKEN = '/fhir/token/'

export const fetchEmrFhirTokens = (emr) => {
  const url = BASE_URL + EMR_TOKEN + emr
  return fetch(url, {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      auth: loSto.get('okta-token-storage')?.idToken?.value
    }
  })
    .then((response) => response.json())
    .catch((error) => {
      return {
        error: `Failed to fetch fhir token details: ${error}`
      }
    })
}

export const updateEmrFhirTokens = (emr, fhirAccessToken, fhirIdToken, fhirRefreshToken) => {
  const url = BASE_URL + EMR_TOKEN + emr
  return fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      auth: loSto.get('okta-token-storage')?.idToken?.value
    },
    body: JSON.stringify({
      fhirAccessToken,
      fhirIdToken,
      fhirRefreshToken
    })
  })
    .then((response) => response.json())
    .catch((error) => {
      return {
        error: `Failed to fetch Embed user details: ${error}`
      }
    })
}
